import React from "react";
import PropTypes from "prop-types";

export default class Card extends React.PureComponent {
  render() {
    return (
      <div
        className="slider24smi__slide"
        ref={el => (this.base = el)}
        onDragStart={e => {
          e.preventDefault();
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

Card.propTypes = {};
